import { Center } from './center';

export enum Action {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  ENISUPLOAD = 'enisupload',
  ENISSYNC = 'enissync',
  APPROVALREQUEST = 'approvalrequest',
  APPROVALAPPROVED = 'approvalapproved',
  APPROVALDENIED = 'approvaldenied',
  CROSSMATCHEXCLUDED = 'crossmatchexcluded',
  CROSSMATCHPOSITIVE = 'crossmatchpositive',
  CROSSMATCHNEGATIVE = 'crossmatchnegative',
  CROSSMATCHREMOVED = 'crossmatchremoved',
  MATCHRUN = 'matchrun',
  CHAINLOCKED = 'chainlocked',
  CHAINUNLOCKED = 'chainunlocked',
  SELECTEDFORTRANSPLANTATION = 'selectedfortransplantation',
  TRANSPLANTED = 'transplanted'
}

export enum TimelineType {
  DONOR = 'donor',
  RECIPIENT = 'Recipient',
  PAIR = 'pair',
  CHAIN = 'chain'
}
export class Timeline {
  id!: string;
  action!: Action;
  centerName!: string;
  actionByUser!: string;
  actionCount!: string;
  date!: Date;
  dateCreated!: Date;
  timelineType!: TimelineType;
}

export class TimelineHistory {
  id!: string;
  action!: Action;
  centerName!: string;
  actionByUser!: string;
  actionCount!: string;
  date!: Date;
  dateCreated!: Date;
  changes?: HistoryChanges[];
  timelineType!: TimelineType;
  typeId!: string;
}

class HistoryChanges {
  field!: string; // Name of the field being updated
  oldValue!: string | null; // Previous value of the field
  newValue!: string | null; // Updated value of the field
}

//This is used to summarize the timelines per hospital / per month. When expanded it turns into the timelines one.
export class CompactTimeline {
  create?: number;
  update?: number;
  delete?: number;
  active?: number;
  inactive?: number;
  enisupload?: number;
  enissync?: number;
  enissyncUpdated?: number;
  approvalrequest?: number;
  approvalapproved?: number;
  approvaldenied?: number;
  crossmatchexcluded?: number;
  crossmatchpositive?: number;
  crossmatchnegative?: number;
  crossmatchremoved?: number;
  matchruns?: number;
  altruists?: number;
  recipients?: number;
  chainlocked?: number;
  chainunlocked?: number;
  selectedfortransplantation?: number;
  transplanted?: number;
  centerName!: string;
  dateStart!: Date;
  dateEnd!: Date;
  user!: string;
  timelines!: Timeline[];
}
